<template>
    <div>

        <v-layout row justify-center>
            <v-dialog  v-model="mustShowSendAssessmentPopup"  persistent max-width="50%" class="popup-scoring popup-scoring-assessment" id="close-label-popup">
                <v-card class="popup-scoring sendAssessment popup-scoring-assessment">
                    <v-card-title class="headline">
                        <span class="font-weight-light">{{text('db.global.TYPE_GTS_SUMMARY_TITLE_D')}}</span>
                        <span  @click="hideSendAssessmentPopup()" class="float-right">
                              <img alt="close icon" src="../../../assets/svg/material-icons-alternatives/Close_White.svg" width="24px" height="24px">
                        </span>
                    </v-card-title>
                    <v-card-text v-if="!sentFlag">
                        <v-form v-model="valid" ref="form">
                            <v-flex xs12 sm12>
                                <v-text-field
                                    v-model="email"
                                    solo
                                    :placeholder="text('api.summary.communication.summary.mail')"
                                    :rules="emailRules"
                                    :class="{'field-highlighted': crtField === 'EMAIL_FIELD'}"
                                    @click="navClickOnEmailField()"
                                    clearable
                                    ref="EMAIL_FIELD"
                                ></v-text-field>
                                <br />
                                <v-checkbox ref="CHECKBOX_COPY_FIELD"
                                            v-model="checkbox"
                                            :class="{'checkbox-highlighted': crtField === 'CHECKBOX_COPY_FIELD'}"
                                            :label="text('api.summary.communication.summary.link')"
                                            @click="navClickOnCopyCheckboxField()"
                                            @blur="navBlurCheckboxCopyField()"
                                            color="primary">
                                </v-checkbox>
                            </v-flex>
                            <v-flex xs6 v-if="!getIsAssessmentSealed && currentRouteName === 'ScoringPage'">
                                <span class="font-weight-light text-sealed">{{text('api.scoring.sealed.send.popup.text')}}</span>
                            </v-flex>
                        </v-form>
                    </v-card-text>
                    <v-card-text v-if="sentFlag">
                        <p class="successfulSent">{{ text('api.scoring.send.popup.text') }}</p>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn v-if="!sentFlag" @click="sendAssessment(), setSentFlagFalse()"  :disabled="valid === false" color="primary">{{text('api.button.send')}}</v-btn>
                        <v-btn v-if="!sentFlag" @click="hideSendAssessmentPopup()">{{ text('api.button.cancel') }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

    </div>
</template>

<!-- ################################################################## -->

<script>
import {mapActions, mapGetters} from 'vuex';
import axios from 'axios';

const SEND_EMAIL_FIELDS = {
        EMAIL_FIELD: "EMAIL_FIELD",
        CHECKBOX_COPY_FIELD: "CHECKBOX_COPY_FIELD",
    };

    export default {
        name: 'SendAssessmentPopup',

        data () {
            return {
                valid: false,
                email: '',
                checkbox: false,
                crtField: "EMAIL_FIELD",
                emailRules: [
                    (value) => (value || "").length > 0 || this.text("api.error.field.required"),
                    (value) => {
                        let regex = /^(([a-zA-Z0-9_\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00df\-.]+)@((\[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00df\-]+\.)+))([a-zA-Z\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00df]{2,15}|[0-9]{1,3})(]?)(\s*\040\s*|\s*$))*$/;
                        return regex.test(value) || this.text("api.error.email.invalid");
                    }
                ]
            }
        },

        computed: {
            ...mapGetters({
                mustShowSendAssessmentPopup: 'ScoringStore/getMustShowSendAssessmentPopup',
                sentFlag: 'ScoringStore/getAssessmentSent',
                datasummary: 'SummaryStore/getSummaryDataNew',
                getAssessmentVersion: 'SummaryStore/getAssessmentVersion',
                getIsAssessmentSealed: 'ScoringStore/getIsAssessmentSealed'
            }),
            currentRouteName() {
                return this.$route.name;
            }
        },

        methods: {
            ...mapActions({
                showSendAssessmentPopup: 'ScoringStore/showSendAssessmentPopup'
            }),

            hideSendAssessmentPopup() {
                this.$refs.form.reset();
                this.$store.commit('ScoringStore/setMustShowSendAssessmentPopup', false);
            },

            setSentFlag(){
                this.$store.commit('ScoringStore/setAssessmentSent', true);
            },

            setSentFlagFalse(){
                let that = this;
                setTimeout(function(){that.$store.commit('ScoringStore/setAssessmentSent', false);}, 2300);
            },

            sendAssessment() {
                this.$refs.form.validate();

                let requestParams = {
                    email: this.email,
                    sendEmailToUser: this.checkbox,
                    assessmentToken: this.getAssessmentToken,
                    assessmentVersion: this.getAssessmentVersion
                };

                let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/sendAssessmentEmail', requestParams);

                axiosRequest.then((response) => {
                    console.log("accept data");
                    console.log(response);

                    this.$store.commit('ScoringStore/setIsAssessmentSealed', true);

                    this.setSentFlag()
                    let that = this;
                    setTimeout(function(){that.$store.commit('ScoringStore/setMustShowSendAssessmentPopup', false);}, 2000);
                });
                axiosRequest.catch((error) => {
                    console.log(error);
                });
            },

            /*******************************
             ***   KEYBOARD NAVIGATION   ***
             ***      BEGIN CODE         ***
             *******************************/

            handleKeyDowns: function(event) {

                switch (event.keyCode) {

                    // Tab
                    case 9:
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false;
                }

                if (this.mustShowSendAssessmentPopup === false) {
                    return;
                }

                // Confirm Print Pdf
                switch (event.keyCode) {

                    // Backspace
                    case 8:
                        if (this.$refs["EMAIL_FIELD"].isFocused === true) {
                            return;
                        }
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false;

                    // Enter
                    case 13:
                        // Enter
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {

                            if (this.crtField === SEND_EMAIL_FIELDS.CHECKBOX_COPY_FIELD) {
                                this.$refs["CHECKBOX_COPY_FIELD"].originalToggle();
                                break;
                            }
                        }

                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();

                        // CTRL + Enter = OK
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true) {

                            this.$refs["CHECKBOX_COPY_FIELD"].$el.blur();
                            this.crtField = SEND_EMAIL_FIELDS.EMAIL_FIELD;
                            this.$refs["EMAIL_FIELD"].focus();

                            if (this.valid === false) {
                                return false;
                            }
                            else {
                                this.$parent.shortcutNav.crtField = null;
                                this.sendAssessment();
                                this.setSentFlagFalse();
                            }
                            return false;
                        }
                        break;

                    // Escape
                    case 27:
                        this.hideSendAssessmentPopup();
                        this.crtField = SEND_EMAIL_FIELDS.EMAIL_FIELD;
                        break;

                    // ArrowUp
                    case 38:
                        event.preventDefault();
                        this.navigateUpDownInSendEmailPopup();
                        break;

                    // Arrow Down
                    case 40:
                        event.preventDefault();
                        this.navigateUpDownInSendEmailPopup();
                        break;

                    // M
                    case 77:
                        // ALT + M
                        if (event.shiftKey === false && event.altKey === true && event.ctrlKey === false) {
                            // focus on textarea comment
                            event.preventDefault();
                            this.hideSendAssessmentPopup();
                            this.navPatientCommentFocusFromPopup();
                        }
                        break;
                }
            },

            handleKeyUps(event) {

                switch (event.keyCode) {

                    // Tab
                    case 9:
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false;
                }
            },

            navBlurCheckboxCopyField() {
                this.$refs["CHECKBOX_COPY_FIELD"].$el.blur();
                this.crtField = null;
            },

            navigateUpDownInSendEmailPopup() {

                if (this.crtField === null) {
                    this.crtField = SEND_EMAIL_FIELDS.EMAIL_FIELD;
                }

                switch (this.crtField) {
                    case(SEND_EMAIL_FIELDS.EMAIL_FIELD):
                        this.crtField = SEND_EMAIL_FIELDS.CHECKBOX_COPY_FIELD;

                        let that = this;
                        setTimeout(function () {
                            that.$refs["CHECKBOX_COPY_FIELD"].$el.focus();
                        }, 500);
                        this.$refs["EMAIL_FIELD"].$el.blur();
                        break;

                    case(SEND_EMAIL_FIELDS.CHECKBOX_COPY_FIELD):
                        this.crtField = SEND_EMAIL_FIELDS.EMAIL_FIELD;
                        this.$refs["EMAIL_FIELD"].$el.focus();
                        that = this;
                        setTimeout(function () {
                            that.$refs["EMAIL_FIELD"].focus();
                        }, 500);
                        this.$refs["CHECKBOX_COPY_FIELD"].$el.blur();
                        break;
                }

            },

            navPatientCommentFocusFromPopup() {

                // Activate navigation on MyDecisionPanel and PatientComment textarea
                if (this.$parent.shortcutNav.isKeyboardNav === false) {
                    // Entering in navigation mode
                    this.$parent.shortcutNav.isKeyboardNav = true;
                }

                this.$parent.shortcutNav.crtPanel = "MY_DECISION";
                this.$parent.shortcutNav.crtField = "PATIENT_COMMENT";
                this.$parent.navScrollOnActivePanel();

                /**
                 * Focus on patient comment textarea. Add border with primary color, for 1 second.
                 */
                let that = this.$parent;
                if (this.$parent.getIsAssessmentSealed === true) {
                    setTimeout(function () {
                        that.shortcutNav.crtField = null
                    }, 500);
                }

                // Patient comment Textarea will be directly editable if the panel is not disabled
                if (this.$parent.getIsAssessmentSealed === false) {
                    this.$parent.shortcutNav.isFieldInEdit = true;
                }

                // Sanity assignment for having the same configuration
                this.$parent.shortcutNav.isPanelHighlight = false;

                this.$parent.$refs['PATIENT_COMMENT'].$refs.input.focus();
            },

            customToggle(e) {
                console.log("customToggle do nothing");
            },

            navClickOnEmailField() {

                this.crtField = SEND_EMAIL_FIELDS.EMAIL_FIELD;
                this.$refs["EMAIL_FIELD"].$el.focus();

                let that = this;
                setTimeout(function () {
                    that.$refs["EMAIL_FIELD"].focus();
                }, 500);

                this.$refs["CHECKBOX_COPY_FIELD"].$el.blur();
            },

            navClickOnCopyCheckboxField() {

                this.crtField = SEND_EMAIL_FIELDS.CHECKBOX_COPY_FIELD;

                let that = this;
                setTimeout(function () {
                    that.$refs["CHECKBOX_COPY_FIELD"].$el.focus();
                }, 500);
                this.$refs["EMAIL_FIELD"].$el.blur();

                this.checkbox = !this.checkbox;
            }

            /*******************************
             ***   KEYBOARD NAVIGATION   ***
             ***        END CODE         ***
             *******************************/

        },

        created: function() {
            document.addEventListener('keydown', this.handleKeyDowns);
            document.addEventListener('keyup', this.handleKeyUps);
        },

        destroyed: function() {
            document.removeEventListener('keydown', this.handleKeyDowns);
            document.removeEventListener('keyup', this.handleKeyUps);
        },

        mounted() {

            this.vCheckboxObj = this.$refs["CHECKBOX_COPY_FIELD"];

            let originalToggle = this.vCheckboxObj.toggle;
            this.vCheckboxObj.toggle = this.customToggle;
            this.vCheckboxObj.originalToggle = originalToggle;

        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>
   /* .popup-scoring-assessment {

        &.card {
            padding: 0;

            .card__title {
                background-color: $color-brand-primary;
                display: block;
                padding: 20px 40px;

                .icon {

                    &:hover {
                        cursor: pointer;
                    }

                }
            }

            .card__text {
                padding: 40px;
            }

            .card__actions {
                padding: 15px 40px;
            }

        }

        p {
            font-size: $font-size-small;
            color: $color-headings-text;
            margin-bottom: 0;
        }

        .successfulSent {
            font-size: $font-size-medium;
            color: #ccff00;

        }

        .ambulance-scoring {
            position: relative;
            top: 7px;
            right: 7px;
        }
    }*/
</style>




// WEBPACK FOOTER //
// src/professional/components/scoring/SendAssessmentPopup.vue